import React from "react";
import { Bar } from "react-chartjs-2";
import { chart as ChartJS } from "chart.js/auto";

const BarChart = ({ ChartData }) => {
  return (
    <div>
      <Bar data={ChartData} />
    </div>
  );
};

export default BarChart;
